import {styled} from "@mui/material/styles";
import {Button} from "@mui/material";

const Button1 = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: 'rgb(0,174,239)',
    borderColor: 'rgb(0,174,239)',
    color:'rgb(24,30,37)',
    '&:hover': {
        backgroundColor: 'rgb(61,193,243)',
        borderColor: 'rgb(61,193,243)',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: 'rgb(0,174,239)',
        borderColor: 'rgb(0,174,239)',
    },
    '&:focus': {
        boxShadow: '0 0 0 0.2rem rgba(0, 174, 239, 0.15)',
    },
});
export default Button1;